export const WIDGET_VIDEO_TYPE = 'video';

/**
 * Contains some common URL pattern for the video that needs a placeholder.
 */
export const URL_PATTERNS = {
    microsoft: ['sharepoint.com', 'microsoftstream.com'],
};
